var _path, _path2, _rect, _g, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBoiler(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_1",
    "data-name": 1,
    xmlns: "http://www.w3.org/2000/svg",
    width: 46.39,
    height: 58.245,
    viewBox: "0 0 46.39 58.245",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M11.428,20.485H7.912a2.658,2.658,0,0,1-2.638-2.672V13.269A4.446,4.446,0,0,0,8.791,8.906V7.125A1.772,1.772,0,0,0,7.033,5.344V.891a.879.879,0,1,0-1.759,0V5.344H3.516V.891a.879.879,0,1,0-1.758,0V5.344A1.771,1.771,0,0,0,0,7.125V8.906a4.445,4.445,0,0,0,3.516,4.363v4.544a4.431,4.431,0,0,0,4.4,4.453h3.56a1.639,1.639,0,0,0,.076.4C11.6,22.67,11.428,20.485,11.428,20.485Z",
    transform: "translate(4.83 29.473)",
    fill: "#00a3da"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Combined_Shape",
    "data-name": "Combined Shape",
    d: "M6,0H18.243a6,6,0,0,1,6,6V52.245a6,6,0,0,1-6,6H6a6,6,0,0,1-6-6V6A6,6,0,0,1,6,0Z",
    transform: "translate(16.605)",
    fill: "#e6f6fb"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    width: 18.702,
    height: 51.227,
    rx: 2,
    transform: "translate(19.376 3.509)",
    fill: "#fff",
    stroke: "#e6f6fb",
    strokeMiterlimit: 10,
    strokeWidth: 1.2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "flash",
    transform: "translate(0 43.512)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M6.753,4.238a.227.227,0,0,0-.2-.117H3.576l.5-3.866A.232.232,0,0,0,3.924.013a.227.227,0,0,0-.268.092L.034,6.535a.233.233,0,0,0,0,.233.227.227,0,0,0,.2.118H3.162l-.4,3.872A.232.232,0,0,0,2.922,11a.227.227,0,0,0,.265-.1L6.75,4.47a.233.233,0,0,0,0-.232Z",
    transform: "translate(0 0)",
    fill: "#00a3da"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M24.243,24.561H2.621A2.638,2.638,0,0,1,0,21.906H0A2.638,2.638,0,0,1,2.621,19.25h8.325A2.235,2.235,0,0,0,13.166,17h0a2.235,2.235,0,0,0-2.22-2.249H2.311A2.327,2.327,0,0,1,0,12.41H0a2.327,2.327,0,0,1,2.311-2.342h8.27A2.6,2.6,0,0,0,13.166,7.45h0a2.6,2.6,0,0,0-2.585-2.619h-8.2A2.4,2.4,0,0,1,0,2.415H0A2.4,2.4,0,0,1,2.384,0H24.243",
    transform: "translate(22.147 8.421)",
    fill: "none",
    stroke: "#00a3da",
    strokeMiterlimit: 10,
    strokeWidth: 2.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoiler);
export default __webpack_public_path__ + "static/media/boiler.facee89bf284d44db8d6acda40e734b5.svg";
export { ForwardRef as ReactComponent };